// John Eldhose 20190506
import { RestfulPost } from './Restful';

export async function contactSales(data) {
  const contact = await RestfulPost('contactSales', data, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return contact;
}



// WEBPACK FOOTER //
// ./src/Api/contactSales.js